import { z } from 'zod'
import { addInvoiceChargesSchema } from '@/features/invoices/schemas'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()

export const addInvoiceChargesToInvoice = (invoiceId: number, charges: z.infer<typeof addInvoiceChargesSchema>) =>
    validateResponseIsOk(
        client.sendPost(`billing/invoices/${invoiceId}/charges`,
            { data: addInvoiceChargesSchema.parse(charges) }
        )
    ).then(
        () => { }
    )